import {validateField, clearFields, setFieldOptions, setCheckBoxValue} from './helpers/form'
import {
  SET_VACANCY_CRITERIA_DROPDOWN_OPTIONS,
  VALIDATE_VACANCY_CRITERIA_DIRECTOR_FIELD,
  CLEAR_VACANCY_CRITERIA_DIRECTOR_FIELDS,
  SET_VACANCY_CRITERIA_CHECKBOX_VALUE
} from '../../../actions/pages/vacancy-page'

export function vacancyCriteriaDirector (
  state = {
    valid: false,
    fields: [
      {
        name: 'SkillLevel',
        value: '',
        errors: [],
        rules: {
          title: 'Rating'
        },
        placeholder: 'Any level',
        options: []
      },
      {
        name: 'NativeLanguage',
        value: '',
        errors: [],
        rules: {
          title: 'Native language'
        },
        placeholder: 'Any language',
        options: []
      },
      {
        name: 'AdditionalLanguage',
        value: '',
        errors: [],
        rules: {
          title: 'Additional language'
        },
        placeholder: 'Any language',
        options: []
      },
      {
        name: 'AgeFrom',
        value: '',
        errors: [],
        rules: {
          title: 'Age from'
        },
        placeholder: 'Any age',
        options: []
      },
      {
        name: 'AgeTo',
        value: '',
        errors: [],
        rules: {
          title: 'Age to'
        },
        placeholder: 'Any age',
        options: []
      },
      {
        name: 'City',
        value: '',
        errors: [],
        rules: {
          title: 'Preferred  city'
        },
        placeholder: 'Any city',
        options: []
      },
      {
        name: 'CountryofLiving',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Country of residence'
        },
        placeholder: 'Any country',
        options: []
      },
      {
        name: 'Region',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Region'
        },
        placeholder: 'Any region',
        options: []
      },
      {
        name: 'Ethnicity',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Ethnicity'
        },
        placeholder: 'Any ethnicity',
        options: []
      },
      {
        name: 'Identity',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Identity'
        },
        placeholder: 'Any identity',
        options: []
      },
      {
          name: 'DoNotUse',
          value: '',
          type: 'checkbox',
          errors: [],
          rules: {
            title: 'Do not use'
          },
          options: []
      },
      {
        name: 'KnownTalent',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Known talent'
        }
      },
      {
        name: 'SkillVendorStatus',
        value: '',
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Inactive talent'
        },
        options: []
      },
      {
        name: 'DirectorTheatricalExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Theatrical'
        }
      },
      {
        name: 'DirectorTVExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'TV'
        }
      },
      {
        name: 'DirectorGamesExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Video Games'
        }
      },
      {
        name: 'DirectorPromoOrCommercialsExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Promo/Commercials'
        }
      },
      {
        name: 'DirectorLiveActionExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'L/A'
        }
      },
      {
        name: 'DirectorAnimationExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Animation'
        }
      },
      {
        name: 'DirectorDubbingDirectorExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Dubbing Director'
        }
      },
      {
        name: 'DirectorVoiceOverDirectorExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'V/O Director'
        }
      },
      {
        name: 'DirectorSongDirectorExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Song Director'
        }
      },
      {
        name: 'DirectorDubbingActorExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Dubbing Actor'
        }
      },
      {
        name: 'DirectorStageDirectorExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Stage Director'
        }
      },
      {
        name: 'DirectorMovieDirectorExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'On Camera Director'
        }
      },
      {
        name: 'DirectorAudioDescriptionExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Audio description'
        }
      },
      {
        name: 'DirectorStudios',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Studios',
          url: 'studios',
          profileType: 'Director'
        },
        placeholder: 'Any studio'
      },
      {
        name: 'DirectorClients',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Clients',
          url: 'clients',
          profileType: 'Director'
        },
        placeholder: 'Any client'
      },
      {
        name: 'DirectorSchools',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Schools',
          url: 'schools',
          profileType: 'Director'
        },
        placeholder: 'Any school'
      },
      {
        name: 'DirectorRemoteRecordingCapability',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Remote recording'
        },
        placeholder: 'Any status',
        options: []
      },
      {
        name: 'DirectorAppAccessRevoked',
        value: false,
        type: 'select',
        errors: [],
        rules: {
          title: 'Director app access',
        },
        placeholder: 'Any status',
      }
    ]
  },
  action
) {
  switch (action.type) {
    case SET_VACANCY_CRITERIA_DROPDOWN_OPTIONS: {
      var newState = setFieldOptions(state, 'SkillLevel', action.skillLevels);
      newState = setFieldOptions(newState, 'City', action.cities);
      newState = setFieldOptions(newState, 'NativeLanguage', action.nativeLanguages);
      newState = setFieldOptions(newState, 'AdditionalLanguage', action.languages);
      newState = setFieldOptions(newState, 'AgeFrom', action.ageFromList);
      newState = setFieldOptions(newState, 'CountryofLiving', action.country);
      newState = setFieldOptions(newState, 'Region', action.region);
      newState = setFieldOptions(newState, 'Ethnicity', action.ethnicity);
      newState = setFieldOptions(newState, 'Identity', action.identity);
      newState = setFieldOptions(newState, 'DirectorRemoteRecordingCapability', action.remoteRecordingDirector);
      return setFieldOptions(newState, 'AgeTo', action.ageToList);
    }

    case SET_VACANCY_CRITERIA_CHECKBOX_VALUE: {
      var newState = setCheckBoxValue(state, 'KnownTalent', action.knownTalent);
      newState = setCheckBoxValue(newState, 'SkillVendorStatus', action.skillVendorStatus);
      return setCheckBoxValue(newState, 'DoNotUse', action.doNotUse);
    }

    case VALIDATE_VACANCY_CRITERIA_DIRECTOR_FIELD: {
      return validateField(state, action);
    }

    case CLEAR_VACANCY_CRITERIA_DIRECTOR_FIELDS: {
      return clearFields(state);
    }

    default:
      return state
  }
}
